export const makeFormData = (data: [string, any][]) => {
  const result = new FormData();

  for (let [key, value] of data) {
    result.append(key, value);
  }

  return result;
};
